import { AUTH_TYPE } from "./Types";

export const initialAuthState = {
  loading: false,
  name: "",
  role: "",
  id: "",
  email: "",
  loginFailed: null,
  loginSuccess: null,
};

export function authReducer(state, action) {
  switch (action.type) {
    case AUTH_TYPE.NAME:
      return { ...state, name: action.payload };
    case AUTH_TYPE.IS_LOADING:
      return { ...state, loading: action.payload };
    case AUTH_TYPE.LOGIN_FAILED:
      return { ...state, loginFailed: action.payload };
    case AUTH_TYPE.LOGIN_SUCCESS:
      return { ...state, loginSuccess: action.payload, loginFailed: null };
    case AUTH_TYPE.ROLE:
      return { ...state, role: action.payload };
    case AUTH_TYPE.ID:
      return { ...state, id: action.payload };
    case AUTH_TYPE.EMAIL:
      return { ...state, email: action.payload };
    case AUTH_TYPE.LOGOUT:
      return { ...initialAuthState };
    default:
      return state;
  }
}
